// extracted by mini-css-extract-plugin
export default {"container":"brand-summary_container__1IdCB","image":"brand-summary_image__24VmS"};